import * as React from 'react';
import * as S from './styles';
import { Keyword } from 'features/Dealers/Listings/Keywords/state/types';

export interface ViewKeywordsProps {
  keywordsState: Keyword[];
}

const PREVIEW_LENGTH = 10;

const ViewKeywords: React.FC<ViewKeywordsProps> = (props) => {

  const [showAll, setShowAll] = React.useState(false);

  const keywords = showAll || props.keywordsState.length <= PREVIEW_LENGTH ? props.keywordsState : props.keywordsState.slice(0, PREVIEW_LENGTH);

  return (
    <S.ViewKeywordContainer>
      <S.ViewKeywordSection>
        <S.ViewKeywordTitle>
          <S.ViewKeywordLabelDescription>
            Keywords
          </S.ViewKeywordLabelDescription>
          <S.ViewKeywordLabelStatus>
            Location
          </S.ViewKeywordLabelStatus>
        </S.ViewKeywordTitle>
        <S.ViewKeywordList>
          {
            keywords.map((keywordData, index) => {
              return (
                <S.ViewKeywordLabel key={index}>
                  <S.ViewKeywordLabelDescription>
                    {keywordData.keywords.join(', ')}
                  </S.ViewKeywordLabelDescription>
                  <S.ViewKeywordLabelStatus>
                    {keywordData.locationName}
                  </S.ViewKeywordLabelStatus>
                </S.ViewKeywordLabel>
              )
            })
          }
        </S.ViewKeywordList>
        { props.keywordsState.length > PREVIEW_LENGTH &&
            <S.ShowAllButton
              onClick={() => setShowAll(!showAll)}
            >
              {
                showAll ? `See less` : `See all (${props.keywordsState.length} Total)`
              }
            </S.ShowAllButton>
          }
      </S.ViewKeywordSection>
    </S.ViewKeywordContainer>
  )
}

export default ViewKeywords